import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useDialogController } from '@machobear/design-system'
import { path, omit } from 'ramda'
import Header from '@/components/header'
import Sidebar from '@/components/sidebar'
import { AgreementModal } from '@/pages/Pages/agreement'
import { Layout, Wrapper, Content } from '@/components/structure'
import { useSidebarContext } from './hooks/use-sidebar-context'
const OMIT_LIST = ['trreb_agreements']

export const AgreeToTerms = ({ session, children }) => {
  const { isSidebarOpen, setIsSidebarOpen } = useSidebarContext()
  const dispatch = useDispatch()
  const userAgreements = useSelector(path(['session', 'session', 'agreements']))
  const mismatched = useSelector(path(['agreement', 'mismatched']))
  const requiredAgreements = omit(OMIT_LIST, mismatched)

  const { visible, showModal, closeModal } = useDialogController(false)
  const mismatchLength = requiredAgreements ? Object.keys(requiredAgreements).length : 0
  const registrationComplete = session?.registration_complete
  const showAgreementModal = mismatchLength > 0 && registrationComplete === '1'

  useEffect(() => {
    dispatch.agreement.validateAgreements()
  }, [dispatch.agreement, userAgreements])

  useEffect(() => {
    if (showAgreementModal) {
      showModal()
    }
  }, [showAgreementModal, showModal])

  if (showAgreementModal) {
    return (
      <Wrapper>
        <Sidebar expanded={isSidebarOpen} setSidebar={setIsSidebarOpen} />
        <Content sidebarExpanded={isSidebarOpen} isFullWidth={false}>
          <Header sidebarExpanded={isSidebarOpen} setSidebar={setIsSidebarOpen} />
          <Layout>
            <AgreementModal visible={visible} closeModal={closeModal} />
          </Layout>
        </Content>
      </Wrapper>
    )
  }
  return children
}
